import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { language, changeLanguage, t } = useLanguage();

  return (
    <div className="language-selector">
      <label className="language-label">{t('common.language', 'Language')}:</label>
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-select"
      >
        <option value="en">{t('common.english', 'English')}</option>
        <option value="da">{t('common.danish', 'Danish')}</option>
      </select>
    </div>
  );
};

export default LanguageSelector;

